import React, { useEffect, useState } from 'react';
import { axiosInstance } from "../../utils/axios.js";
import TimeSlot from '../ReserveCom/TimeSlot';  // TimeSlotコンポーネントを作成する必要があります
import { LuCigaretteOff } from "react-icons/lu";
import { BrowserRouter, Routes, Route, NavLink, useParams } from 'react-router-dom';
import { CreditCard, FileText, Calculator, ArrowRight, CheckCircle } from 'lucide-react';


const PaymentBillContainer = (props) => {
  const [billingInfo, setBillingInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [ratio,setRatio] = useState(0.3);

    useEffect(() => {
    axiosInstance.get(`/payments/${id}`, {
      headers: {
        'uid': props.token,  // ここにアクセストークンをしっかり渡す
        'Access-Control-Allow-Origin': '*'
        
      }
    })
      .then(response => {
          setBillingInfo(response.data.billing_info);
          setIsLoading(false);
          setRatio(response.data.billing_info.total.ratio)
          console.log(response.data.billing_info.total.ratio)
      });
  }, []);


if (isLoading) {
  return (
    <div>
      <div className="loader" style={{ width: '100px', height: '100px' }}></div>
      <div
        style={{
          width: '100%',
          position: 'absolute',
          bottom: '0%',
          height: '80px',
          background: '#FEFBF9',
          zIndex: '12',
        }}
      />
    </div>
  );
}

return (
  <div className="sunny_container" style={{paddingBottom:'120px'}}>
    <div className="mypage_reservation payment_page">
      <div className="payment_steps">
        <div className="step active">
          <CheckCircle className="step_icon" />
          <span>1</span>
        </div>
        <div className="step_line"></div>
        <div className="step">
          <CreditCard className="step_icon" />
          <span>2</span>
        </div>
        <div className="step_line"></div>
        <div className="step">
          <ArrowRight className="step_icon" />
          <span>3</span>
        </div>
      </div>

      <div className="payment_header">
        <FileText className="payment_header_icon" />
        <h2 className="mypage_reservation_h1">会計明細</h2>
      </div>

      <div className="mypage_payment_bill modern_bill">
        {/* 保険診療 */}
        {billingInfo.insurance_details.map((detail, index) => (
          <div key={`insurance-${index}`} className="mypage_payment_bill_row modern_row">
            <p className="bill_type">{detail.type}</p>
            <p className="bill_description">{detail.description}</p>
            <p className="bill_amount">
              {detail.score === "---" ? "---" : `${detail.score} 点`}
            </p>
          </div>
        ))}

        {/* 自由診療 */}
        {billingInfo.private_details.map((detail, index) => (
          <div key={`private-${index}`} className="mypage_payment_bill_row modern_row">
            <p className="bill_type">{detail.type}</p>
            <p className="bill_description">{detail.description}</p>
            <p className="bill_amount">¥{detail.cost}</p>
          </div>
        ))}
      </div>

      <div className="bill_divider"></div>

      {/* 合計セクション */}
      <div className="bill_summary">
        <div className="mypage_payment_bill_row summary_row">
          <p>保険点数</p>
          <p>{billingInfo.total.insurance} 点</p>
        </div>

        <div className="mypage_payment_bill_row summary_row">
          <p>自己負担金額</p>
          <p>¥{Math.round((billingInfo.total.insurance * 10 * ratio) / 10.0) * 10}</p>
        </div>

        <div className="mypage_payment_bill_row summary_row">
          <p>給付外小計</p>
          <p>¥{billingInfo.total.private}</p>
        </div>

        <div className="mypage_payment_bill_row summary_row">
          <p>給付外消費税</p>
          <p>¥{billingInfo.total.private_tax}</p>
        </div>

        <div className="mypage_payment_bill_row total_row">
          <p>合計金額</p>
          <p>¥{billingInfo.total.grand_total}</p>
        </div>
      </div>

      <div className="payment_notice">
        <Calculator className="notice_icon" />
        <p>※ご請求内容に問題ないかご確認の上、「次へ進む」を押してください。</p>
      </div>

      <div className="footer_content_page">
        <NavLink 
          to={`/mypage/payment/deliver/${id}`} 
          className="footer_content_page"
          state={{ sum: billingInfo.total.grand_total }}
        >
          <button className="modern_action_button">
            <span>次へ進む</span>
            <ArrowRight className="button_arrow" />
          </button>
        </NavLink>
      </div>
    </div>
  </div>
  );
};

export default PaymentBillContainer;